<template>
  <div class="payment">
    <div class="main-inner">
      <main>
        <section class="form-content" v-if="this.step == 0">
          <h2 class="form-content-title">カード情報変更</h2>
          <p class="form-content-desc">変更を希望する場合は、必要な情報を入力のうえ、下の「次へ」ボタンを押してください。</p>
          <div class="card-alert">※新しいカードのご利用は、次回課金時からになります。</div>
          <div class="form-block">
            <div class="form-block-item --required">
              <div class="form-block-label">カード番号</div>
              <div class="form-block-content">
                <input id="cn" type="text" :class="{ '--error' : inputErrors.cn }" name="cn" v-model="credit.cn" class="--card">
                <p class="form-error" v-if="inputErrors.cn">入力に誤りがあります。</p>
              </div>
            </div>
            <div class="form-block-item --required">
              <div class="form-block-label">名義人</div>
              <div class="form-block-content">
                <input id="fn" type="text" :class="{ '--error' : inputErrors.fn }" name="fn" v-model="credit.fn" class="--name" placeholder="例）TARO">
                <input id="ln" type="text" :class="{ '--error' : inputErrors.ln }" name="ln" v-model="credit.ln" class="--name" placeholder="例）YAMADA">
                <p class="form-error" v-if="inputErrors.fn || inputErrors.ln">入力に誤りがあります。</p>
              </div>
            </div>
            <div class="form-block-item --required">
              <div class="form-block-label">有効期限</div>
              <div class="form-block-content">
                <div class="form-select">
                  <select id="ed_month" type="text" :class="{ '--error' : inputErrors.ed_month }" name="ed_month" v-model="ed_month" class="--expiry">
                    <option :value="String(i).padStart(2,'0')" v-for="i of 12" :key="i">{{String(i).padStart(2,'0')}}</option>
                  </select>
                  <div class="form-select-unit">月</div>
                  <select id="ed_year" type="text" :class="{ '--error' : inputErrors.ed_year }" name="ed_year" v-model="ed_year" class="--expiry">
                    <option :value="i+Number(String((new Date()).getFullYear()).substring(2, 4))-1" v-for="i of 11" :key="i">{{i+Number(String((new Date()).getFullYear()).substring(2, 4))-1}}</option>
                  </select>
                  <div class="form-select-unit">年</div>
                </div>
                <p class="form-error" v-if="inputErrors.ed_month || inputErrors.ed_year">入力に誤りがあります。
                </p>
              </div>
            </div>
            <div class="form-block-item --required">
              <div class="form-block-label">セキュリティコード</div>
              <div class="form-block-content">
                <input id="cvv" type="text" :class="{ '--error' : inputErrors.cvv }" name="cvv" v-model="credit.cvv" class="--code">
                <p class="form-error" v-if="inputErrors.cvv">入力に誤りがあります。</p>
              </div>
            </div>
          </div>
          <div class="button-group">
            <button class="button" @click="$router.push('payment')">キャンセル</button>
            <button class="button" @click="isValidate()">次へ</button>
          </div>
        </section>

        <section class="form-content" v-else-if="this.step == 1">
          <h2 class="form-content-title">変更内容確認</h2>
          <p class="form-content-desc">変更内容をご確認のうえ、お間違いがないようであれば、「変更する」ボタンを押してください。</p>
          <div class="payment-table change_info">
            <table>
              <tr>
                <th>お支払い方法</th>
                <td>クレジットカード決済</td>
              </tr>
              <tr>
                <th>カード番号</th>
                <td>xxxx-xxxx-xxxx-{{cardInfo.lfn}}</td>
              </tr>
            </table>
          </div>
          <div class="button-group">
            <button class="button" @click="decreseStep()">前の画面に戻る</button>
            <button class="button" @click="isCompleted()" :disabled="this.clicked">変更する</button>
          </div>
        </section>

        <section class="form-content" v-else-if="this.step == 2">
          <div class="lead mb-60">
            <h2 class="headline2 mb-10">
              カード情報の変更が完了しました
            </h2>
            <p>
              ご登録のメールアドレス宛に、カード情報変更完了メールをお送りいたしました。
              <br>
              <br>
              24時間を経過してもカード情報変更完了メールが届かない場合は、お手数ですが、お問い合わせフォームからお問い合わせいただきますよう、お願いいたします。
            </p>
          </div>
          <div class="btn-set">
            <span class="button-group">
              <button class="button" @click="reloadTop()">カード情報変更に戻る</button>
            </span>
          </div>
        </section>

        <section class="form-content" v-else-if="this.step == 3">
          <!-- 決済でエラーが起きた時 -->
          <h2 class="form-content-title">変更内容確認</h2>
          <p class="form-content-desc">カード情報の変更に失敗しました。後入力されたクレジットカードをご確認ください。</p>
          <div class="btn-set">
            <span class="button-group">
              <button class="button" @click="reloadTop()">カード情報変更に戻る</button>
            </span>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>
<script>
import httpResource from '../../http/httpResource'
import { mapActions } from 'vuex'
import store from '../../store/index'
import $ from 'jQuery'

export default {
  name: 'CardChange',
  data () {
    return {
      isError: false,
      clicked: false,
      inputErrors: {},
      credit: {
        aid: process.env.ROBOT_PAYMENT_ID,
        cn: '',
        ed: '',
        fn: '',
        ln: '',
        cvv: ''
      },
      ed_year: '',
      ed_month: '',
      resultCode: '',
      errMsg: '',
      cardInfo: {
        // クレジットカード情報
        tkn: '',
        lfn: ''
      },
      step: 0
    }
  },
  mounted () {
    let self = this
    // 監視対象の要素指定
    const cardTkn = $('#tkn')[0]
    // 変化があれば実行する処理
    const observer = new MutationObserver(function () {
      self.pageTransition($('#tkn').val())
    })
    // 要素のテキストノードの変更を監視
    const config = {
      childList: true,
      attributes: true
    }
    // 監視開始
    observer.observe(cardTkn, config)
  },
  methods: {
    ...mapActions(['login', 'updateContract']),
    doPurchase () {
      this.credit.ed = this.ed_year + this.ed_month
      this.cardInfo.lfn = this.credit.cn.substr(12)
      window.CPToken.TokenCreate(this.credit, function (resultCode, errMsg) {
        if (resultCode !== 'Success') {
          window.alert(errMsg)
        } else {
          // 入力フォームを初期化する
          $('#cn').val('')
          $('#ed_year').val('')
          $('#ed_month').val('')
          $('#fn').val('')
          $('#ln').val('')
          $('#cvv').val('')
        }
      })
      console.log('トークン取得完了')
    },
    checkClick () {
      this.clicked = true
    },
    increaseStep (step) {
      this.step += step
    },
    decreseStep () {
      this.step -= 1
    },
    resetStep () {
      this.step = 0
    },
    async isCompleted () {
      this.checkClick()
      try {
        console.log('リクエストを送信')
        const response = await httpResource.post('/corporation/management/card', this.cardInfo, {headers: {Authorization: `Bearer ${store.getters.getAuthData.token}`}})
        if (response.status === 200) {
          console.log('レスポンスの受け取り')
          if (response.data.message === 'SUCCESS') {
            this.increaseStep(1)
          } else {
            this.errMsg = response.data.message
            this.increaseStep(2)
          }
        }
      } catch (error) {
        console.log('レスポンスを受け取れない')
        console.log(error)
        this.increaseStep(4)
      }
    },
    async isValidate () {
      this.inputErrors = {}
      this.isError = false
      this.inputErrors = {
        ...this.inputErrors,
        cn: this.credit.cn.length === 0,
        ln: this.credit.ln.length === 0,
        fn: this.credit.fn.length === 0,
        ed_month: this.ed_month.length === 0,
        ed_year: this.ed_year.length === 0,
        cvv: this.credit.cvv.length === 0
      }

      for (let key in this.inputErrors) {
        if (this.inputErrors[key] === true) {
          this.isError = true
        }
      }

      if (!this.isError) {
        this.doPurchase()
        console.log('入力チェック完了')
      }
    },
    pageTransition (cardTkn) {
      if (cardTkn !== '') {
        this.cardInfo.tkn = cardTkn
        console.log('トークン取得完了、3Dセキュア認証を実施')
        this.authenticate3DS()
      }
    },
    authenticate3DS () {
      console.log(store.getters.getCorporation.email)
      const authData = {
        tkn: this.cardInfo.tkn,
        aid: this.credit.aid,
        am: 0,
        tx: 0,
        sf: 0,
        em: store.getters.getCorporation.email
      }
      window.ThreeDSAdapter.authenticate(authData, (resultCode, resultMessage) => {
        if (resultCode === 'Success') {
          console.log('3Dセキュア認証完了して遷移')
          this.increaseStep(1)
          window.scrollTo({top: 0})
        } else {
          console.log('3Dセキュア認証エラー: ' + resultCode + ' ' + resultMessage)
          this.errMsg = resultMessage
          this.increaseStep(3)
        }
      })
    },
    reloadTop () {
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/card/index.vue